<ul *ngIf="data.problems?.length">
  <li *ngFor="let problem of data.problems"> {{ problem.message }}</li>
</ul>

<div *ngIf="!data.problems || data.problems.length === 0">Bez chyb</div>
